import { isDictationEnabled } from '@/features/dictation/hooks/useIsDictationEnabled';
import { isTauri } from '@/tauri/utils';

/** Check if native Rust audio should be used (desktop with FF enabled). */
export const shouldUseNativeAudio = (): boolean => isTauri() && isDictationEnabled();
